import { Component, OnInit, Input } from '@angular/core';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { FlowCell } from '../masterdata/models/flowcell';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';

@Component({
  selector: 'app-mdm-flowcell',
  templateUrl: './mdm-flowcell.component.html',
  styleUrls: ['./mdm-flowcell.component.css']
})
export class MdmFlowcellComponent implements OnInit {

  @Input() masterLists: FlowCell[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() loading:boolean;
  
  puid = localStorage.getItem('PUID');
  labOption: LabMDM[] = [];
  selectedMasterList: FlowCell;
  popupTitle: string;
  displayMasterListDialog: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  isNewMasterList: boolean;
  masterList: FlowCell;
  selectedLabName: string;
  selectedLab: LabMDM;
  displayName: any;
  blocked: boolean = false;
  sequencerOptions: any[];
  sequencerOption: any[]=[];
  flowCellTypeOptions: any[];
  flowCellModeOptions: any[];
  capabilityModeOptions: any[];
  physicalLaneLimit: number = 5;
  capabilityList: any[];
  flowCellCapabilities: string[];
  selectedSequencer: any;
  selectedFlowCellType: any;
  selectedFlowCellMode: any;
  selectedCapabilityMode: any;
  capabilityLength: number;

  capabilityDuration: number;
  dialogBoxCell: boolean = false;
  readModeCountList = [];
  flowCellReadMode =[];
  capabilityListMode = [];
  oldCellMode: string;
  newCellMode : string;


  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) { }


  ngOnInit() {
    this.getActiveOptionsForDropdowns();

    this.flowCellTypeOptions = [
      {label:'MiSeq', name:'MiSeq'},
      {label:'SP', name:'SP'},
      {label:'S1', name:'S1'},
      {label:'S2', name:'S2'},
      {label:'S4', name:'S4'},
      {label:'X 1.5', name:'X 1.5'},
      {label:'X 10', name:'X 10'},
      {label:'X 25', name:'X 25'}
      ];

      this.flowCellModeOptions = [
        {label:'Std', name:'Std'},
        {label:'XP', name:'XP'}
      ];

      this.capabilityModeOptions = [
        {label: "PE", name:"PE"},
        {label: "SR", name:"SR"}
      ];

  }

  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new FlowCell;
    this.displayMasterListDialog = true;
    this.masterList.physicalLanes = 1;
    this.masterList.logicalLanes = 1;
    this.masterList.totalCapacity = 1;
    this.masterList.laneCapacity = 1;
    this.capabilityList = [];
    this.readModeCountList = [];
    this.capabilityListMode = [];
    this.getActiveOptionsForDropdowns();

  }

  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.getSelectedDropDownValues();
    this.getFlowCellCapabilities();
    this.selectedCapabilityMode = null;
  }

  getSelectedDropDownValues(){
    this.flowCellTypeOptions.forEach(cellType => {
      if(cellType.name == this.masterList.flowCellType){
        this.selectedFlowCellType = {label: cellType.name, name: cellType.name};
      }
    });

    this.flowCellModeOptions.forEach(cellMode => {
      if(cellMode.name == this.masterList.flowCellMode){
        this.selectedFlowCellMode = {label: cellMode.name, name: cellMode.name};
      }
    });
  }

  getFlowCellCapabilities() {
    this.capabilityList = [];
    this.readModeCountList = [];
    this.capabilityListMode = [];
    this.selectedCapabilityMode = [];
    this.capabilityLength = null;
    this.capabilityDuration = null;
    this.masterList.capabilities.forEach(capability => {
      this.capabilityList.push({ label: capability, name: capability });
    })
    this.masterList.readModeCount.forEach(listMode => {
      this.capabilityListMode.push({ label: listMode.capability + ", " + listMode.readDuration + " hrs.", name: listMode.capability });
      this.readModeCountList.push(listMode);
    })

  }
    
  getActiveOptionsForDropdowns(): any {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      resultLabs => {
        if (!resultLabs) {
          return;
        }  
        let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = resultLabs.data;
        this.labOptions.forEach(lab => {
          
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions= this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

    this.sequencerOption = [];
    this._masterDataService.getMachineTypes(true, this.checkSelectedLab.lab).subscribe(
      resultMachineTypes => {
        if (!resultMachineTypes) {
          return;
        }  
        this.sequencerOptions = resultMachineTypes.data;
        this.sequencerOptions.forEach(machineType => {
          
          if(machineType.sequencer && machineType.active) {
            this.sequencerOption.push({label: machineType.name, name: machineType.name});
          }

          if(this.masterList && this.masterList.sequencer && machineType.name == this.masterList.sequencer){
            var selectedSeq = {label: machineType.name, name: machineType.name};
            this.selectedSequencer = selectedSeq;
          }
        })

        this.sequencerOptions= this.sequencerOption;
        if (!this.masterList || !this.masterList.sequencer || this.selectedSequencer.name != this.masterList.sequencer)
          this.selectedSequencer = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

  }

  isSaveDisabled() {
    return !(this.masterList && this.masterList.flowCellName && this.selectedLab && this.selectedSequencer &&  this.selectedFlowCellType 
      && this.selectedFlowCellMode && !this.physicalLanesCheck() && !this.logicalLanesCheck() && !this.totalCapacityCheck());
  }

  saveMasterListData() { 
    //in case the list not exists for the first time
    if(!this.masterLists){
      this.masterLists = [];
    }
     
    let nameExists = false;
    this.masterLists.forEach(obj =>{
      if(obj.flowCellName == this.masterList.flowCellName){
        nameExists = true;
      }
    })
    if(this.isNewMasterList && nameExists){
      this._messageService.addErrorMessage({ severity: 'error', summary: 'Name Already Exists', detail: 'FlowCell Name already exists'});
      return;
    }
    
    var labObj = new LabMDM();
    labObj._id = this.selectedLab._id;
    labObj.name = this.selectedLab.name;
    labObj.businessArea = this.selectedLab.businessArea;
    this.masterList.lab = labObj;
    this.masterList.sequencer = this.selectedSequencer.name;
    this.masterList.flowCellType = this.selectedFlowCellType.name;
    this.masterList.flowCellMode = this.selectedFlowCellMode.name;
    this.flowCellCapabilities = [];
    this.capabilityList.forEach(cap =>{
      this.flowCellCapabilities.push(cap.name);
    })
    this.masterList.capabilities = this.flowCellCapabilities;
    this.flowCellReadMode = [];
    this.readModeCountList.forEach(mode =>{
      this.flowCellReadMode.push(mode);
    })
    this.masterList.readModeCount = this.flowCellReadMode;
    this.appendHistory("Flow Cells");
    var inputData = JSON.stringify(this.masterList);
    
    if (this.isNewMasterList) {
      this.saveMasterData(inputData);
    }
    else {
      this.updateMasterData(inputData);
    }
  }
  private handleError(error: any) {
    this.blocked=false;
    let errorMessage = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(errorMessage);
  }

  //Inserts a new Template in DB
  saveMasterData(jsonString: string) {
    this.blocked=true;
    this._masterDataService.addFlowCell(jsonString, this.selectedLab._id).subscribe(
      flowCellJson=> {
        if (!flowCellJson) {
          return;
        }
        this.displayMasterListDialog = false;
        this.masterList = flowCellJson.data;
        this.masterLists.push(this.masterList);
        this.masterList = null;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved Work Flow!', detail: 'WorkFlow is created.' });
        this.blocked=false;
      },
      error => {
        this.handleError(error);
        }
    );
  }

  //Updates a Template in DB
  updateMasterData(jsonString: string) {

    this.blocked=true;
      this._masterDataService.updateFlowCell(jsonString, this.selectedLab._id, this.selectedMasterList._id).subscribe(
        flowCellJson => {
          if (!flowCellJson) {
            return;
          }
          this.masterList = flowCellJson;
          this.masterLists[this.masterLists.indexOf(this.selectedMasterList)] = this.masterList;
          this.masterList = null;
          this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated WorkFlow!', detail: 'WorkFlow is Updated.' });
          this.displayMasterListDialog = false;
          this.blocked=false;
        },
        error => {
          this.handleError(error);
          }  
      );
    
    
  }

  updateReadMode() {
    this.masterList.capabilities.forEach(listMode => {
      if (listMode == (this.selectedCapabilityMode.name + " " + this.capabilityLength)) {
        this.capabilityListMode = this.capabilityListMode.filter((item) => item.name !== this.selectedCapabilityMode.name + " " + this.capabilityLength);
        this.capabilityListMode.push({ label: this.selectedCapabilityMode.name + " " + this.capabilityLength + ", " + this.capabilityDuration + " hrs.", name: this.selectedCapabilityMode.name + " " + this.capabilityLength });
        this.capabilityListMode = Object.assign([], this.capabilityListMode);
      }
    })
    this.readModeCountList.forEach(mode => {
      if (mode.capability == (this.selectedCapabilityMode.name + " " + this.capabilityLength)) {
        mode.readDuration = this.capabilityDuration
      }
    })
    this.dialogBoxCell = false;
    this.selectedCapabilityMode = null;
    this.capabilityLength = null;
    this.capabilityDuration = null;
  }

  disableDialog() {
    this.dialogBoxCell = false;
    this.selectedCapabilityMode = null;
    this.capabilityLength = null;
    this.capabilityDuration = null;
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

   //if a flowCellName is existing ,the editing for that fiels is disabled
  isFlowcellName(fieldName) {
    if (this.masterList._id == null || this.masterList._id == '' ||  this.masterList._id == undefined) {
      return false;
    } else if (fieldName == "flowCellName") {
      return true;
    }
  }

  physicalLanesCheck() {
    return (this.masterList.physicalLanes > 8 || this.masterList.physicalLanes < 0 || this.masterList.physicalLanes == null)
  }

  logicalLanesCheck() {
    return ((this.masterList.physicalLanes > 0 && this.masterList.logicalLanes > this.masterList.physicalLanes) || this.masterList.logicalLanes < 0 || this.masterList.logicalLanes == null)
  }

  totalCapacityCheck() {
    return (this.masterList.totalCapacity > 99999 || this.masterList.totalCapacity < 0 || this.masterList.totalCapacity == null)
  }

  onValueChange(){
    this.masterList.laneCapacity = Math.round(this.masterList.totalCapacity / this.masterList.logicalLanes);
  }

  isAddDisabled() {
    return !(this.selectedCapabilityMode && this.capabilityLength && this.capabilityDuration);
  }

  addFlowCellCapability() {
    let flowCellCapability = this.selectedCapabilityMode.name + " " + this.capabilityLength;
    let flowCellCapabilityDuration = this.selectedCapabilityMode.name + " " + this.capabilityLength + ", " + this.capabilityDuration + " hrs.";
    let capExist = false;
    this.capabilityListMode.forEach(cap => {
      //if capability already exists
      if (cap.name == flowCellCapability) {
        if (this.masterList.capabilities == undefined || this.masterList.capabilities.length == 0) {
          this.selectedCapabilityMode = null;
          this.capabilityLength = null;
          this.capabilityDuration = null;
        }
        else {
          capExist = true;
          this.oldCellMode = cap.label;
          this.newCellMode = flowCellCapabilityDuration;
        }
      }
    })
    if (capExist) {
      this.dialogBoxCell = true;
      return;
    }
    this.capabilityList.push({ label: flowCellCapability, name: flowCellCapability });
    this.capabilityListMode.push({ label: flowCellCapabilityDuration, name: flowCellCapability });
    let obj = {
      "readMode": this.selectedCapabilityMode.name,
      "readCount": this.capabilityLength,
      "readDuration": this.capabilityDuration,
      "capability": flowCellCapability
    };
    this.readModeCountList.push(obj);
    this.capabilityListMode = Object.assign([], this.capabilityListMode);
    this.selectedCapabilityMode = null;
    this.capabilityLength = null;
    this.capabilityDuration = null;
  }

  removeFlowCellCapability(capabilityName: any) {
    this.capabilityList = this.capabilityList.filter((item) => item.name !== capabilityName.name);
    this.capabilityListMode = this.capabilityListMode.filter((item) => item.name !== capabilityName.name);
    this.readModeCountList = this.readModeCountList.filter((item) => item.capability !== capabilityName.name);
  }

  appendHistory(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.history){
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }
}
